import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {CONTENT_TYPE, RESERVATION_DRAWER_PAGE_NAME, RESERVATION_EVENTS_TRACKING} from './config.js'

export const useTracking = () => {
  const {track, page} = useAnalyticsTrack()

  const getHitOrigin = currentContent => {
    switch (currentContent) {
      case CONTENT_TYPE.RESERVATION_INFO:
        return 'detail'
      case CONTENT_TYPE.RESERVATION_LEGAL_CONDITIONS:
        return 'condiciones legales'
      case CONTENT_TYPE.RESERVATION_TERMS:
        return 'FAQ'
      default:
        return 'detail'
    }
  }

  const trackHandleButtonOnCkick = ({adInfo, currentContent, hitOrigin}) => {
    track({
      event: RESERVATION_EVENTS_TRACKING.RESERVATION_START_CLICKED,
      data: {
        hit_origin: hitOrigin ?? getHitOrigin(currentContent),
        products: [{id: adInfo?.id, category: 'ads', price: adInfo?.price, quantity: 0}]
      }
    })
  }

  const trackHandleNavigateToTerms = adInfo => {
    track({
      event: RESERVATION_EVENTS_TRACKING.RESERVATION_MORE_INFORMATION_CLICKED,
      data: {
        hit_origin: 'modal acceso faq',
        products: [{id: adInfo?.id, category: 'ads', price: adInfo?.price, quantity: 0}]
      }
    })
  }

  const trackHandleNavigateToTermsBottomBar = adInfo => {
    track({
      event: RESERVATION_EVENTS_TRACKING.RESERVATION_MORE_INFORMATION_CLICKED,
      data: {
        hit_origin: 'modal acceso faq bottom bar',
        products: [{id: adInfo?.id, category: 'ads', price: adInfo?.price, quantity: 0}]
      }
    })
  }

  const trackHandleNavigateToLegalConditions = adInfo => {
    track({
      event: RESERVATION_EVENTS_TRACKING.RESERVATION_MORE_INFORMATION_CLICKED,
      data: {
        hit_origin: 'modal acceso condiciones legales',
        products: [{id: adInfo?.id, category: 'ads', price: adInfo?.price, quantity: 0}]
      }
    })
  }

  const trackHandleOnClose = () => {
    track({
      event: RESERVATION_EVENTS_TRACKING.RESERVATION_MODAL_CLOSED
    })
  }

  const trackReservationDrawerViewed = adInfo => {
    page({
      event: RESERVATION_EVENTS_TRACKING.RESERVATION_DRAWER_VIEWED,
      data: {
        page_name: RESERVATION_DRAWER_PAGE_NAME,
        products: [{id: adInfo?.id, category: 'ads', price: adInfo?.price, quantity: 0}]
      }
    })
  }

  return {
    trackReservationDrawerViewed,
    trackHandleButtonOnCkick,
    trackHandleNavigateToTerms,
    trackHandleNavigateToTermsBottomBar,
    trackHandleNavigateToLegalConditions,
    trackHandleOnClose
  }
}
